const env = {
    server_url: 'http://localhost:3001',
    ws_url: 'ws://hex.loc/api/ws',
    office_url: '',
    debug: true,
    map_key: 'AtlPsALAJKO_5NQBi7JfpWqSckFRW-GrnKgHFd131zD8oZ3qmpD7rscaklGEUARn'
}

export default env;
